import type { Role } from '@/entities/user';

export const promotionsAccessRoles = ['admin'] as const satisfies readonly Role[];
